import { PaymentFormProvider } from "./PaymentFormContext";

interface PaymentProviderProps {
  children: React.ReactNode;
}

export const PaymentProvider = ({ children }: PaymentProviderProps) => {
  return <PaymentFormProvider>{children}</PaymentFormProvider>;
};